import { render, staticRenderFns } from "./VoispeedAdvertise.vue?vue&type=template&id=3d0c6420&scoped=true&"
import script from "./VoispeedAdvertise.vue?vue&type=script&lang=ts&"
export * from "./VoispeedAdvertise.vue?vue&type=script&lang=ts&"
import style0 from "./VoispeedAdvertise.vue?vue&type=style&index=0&id=3d0c6420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c6420",
  null
  
)

export default component.exports